import Vue from "vue";
import $ from "jquery";
// import BootstrapVue from "bootstrap-vue";
// import VueScrollTo from "vue-scrollto";
import {
	store,
	settings,
	currency,
	// auth,
} from "@/loader";
import FaIcon from "./component/FaIcon.vue";
// @ts-ignore no definition file found
import InstantSearch from "vue-instantsearch";
import SearchBar from "./module/public/SearchBar.vue";
import CategoriesMenu from "./module/public/CategoriesMenu.vue";

import "./module/public/scss/style.scss";

$(function() {
	// Vue.use(BootstrapVue);
	// Vue.use(VueScrollTo);
	Vue.use(InstantSearch);
	Vue.component("fa", FaIcon);
	Vue.filter("currency", currency.format);
	// Vue.filter("currencyNoDecimal", currencyNoDecimal.format);
	// Vue.filter("percent", percent.format);
	// auth.init();

	if (document.getElementById("lnc_searchbar")) {
		new Vue({
			el: "#lnc_searchbar",
			store,
			render: (h) => h(SearchBar),
			beforeCreate() {
				settings.init();
			},
		});
	}

	let hoverMainMenu = false;
	let hoverCategoryMenu = false;
	function showCategoriesMenu() {
		console.log({ hoverMainMenu, hoverCategoryMenu });
		$("#lnc_categoriesmenu_display").toggle(hoverMainMenu || hoverCategoryMenu);
	}

	if (document.getElementById("lnc_categoriesmenu")) {
		$("#lnc_categoriesmenu")
			.parents(".menu-item")
				.on("mouseenter", function() { hoverMainMenu = true; showCategoriesMenu(); })
				.on("mouseleave", function() { hoverMainMenu = false; showCategoriesMenu(); })
				.on("click", function() { hoverMainMenu = true; showCategoriesMenu(); })
			.siblings(".menu-item")
				.on("mouseenter", function() { hoverMainMenu = false; showCategoriesMenu(); })
			.parents(".fusion-megamenu")
				.append("<li id='lnc_categoriesmenu_display'></li>");
		$("#menu-main-menu > li")
			.on("mouseenter", function() { hoverMainMenu = false; showCategoriesMenu(); });
		new Vue({
			el: "#lnc_categoriesmenu_display",
			store,
			render: (h) => h(CategoriesMenu),
			beforeCreate() {
				settings.init();
			},
			mounted() {
				$("#lnc_categoriesmenu_display")
					.on("mouseenter", function() { hoverCategoryMenu = true; showCategoriesMenu(); })
					.on("mouseleave", function() { hoverCategoryMenu = false; showCategoriesMenu(); });
			}
		});
	}
});
